export const config = {
  API_URL: `https://admin.healthtunnel.com/api`,
  MAIN_URL: `https://admin.healthtunnel.com`,

};
